import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJiraSoftwareLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 54 54",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M53.3468 25.4885L29.3248 2.25161L26.9971 0L8.91391 17.4921L0.644894 25.4885C0.231861 25.8901 0 26.4335 0 27C0 27.5665 0.231861 28.1099 0.644894 28.5115L17.1655 44.4921L26.9971 54L45.0778 36.5078L45.3594 36.2378L53.3468 28.5236C53.5538 28.3248 53.7181 28.0884 53.8302 27.8279C53.9423 27.5675 54 27.2881 54 27.006C54 26.7239 53.9423 26.4446 53.8302 26.1841C53.7181 25.9237 53.5538 25.6872 53.3468 25.4885ZM26.9971 34.9843L18.743 27L26.9971 19.0157L35.2487 27L26.9971 34.9843Z",
			fill: "#2684FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.9998 18.9709C24.3912 16.4578 22.9207 13.052 22.9094 9.49742C22.8982 5.94287 24.3471 2.52847 26.9397 0L8.79053 17.4819L18.6678 27L26.9998 18.9709Z",
			fill: "url(#paint0_linear_116508_2746)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.606 27L27 35.001C29.7103 37.5206 31.2328 40.9376 31.2328 44.5005C31.2328 48.0633 29.7103 51.4803 27 54L45.2094 36.2571L35.606 27Z",
			fill: "url(#paint1_linear_116508_2746)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_116508_2746",
			x1: 25.5147,
			y1: 10.884,
			x2: 14.3608,
			y2: 22.4564,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .18,
				stopColor: "#0052CC"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2684FF"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_116508_2746",
			x1: 28.6382,
			y1: 42.9779,
			x2: 39.7296,
			y2: 31.0468,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .18,
				stopColor: "#0052CC"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2684FF"
			})]
		})] })
	]
});
const ForwardRef = forwardRef(SvgJiraSoftwareLogo);
export { ForwardRef as ReactComponent };
